export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('sort');
    if (element) {
        tourCriteriaJson.sort = element;
    }

    return tourCriteriaJson;
};